import * as React from 'react';
import { MdPhone } from 'react-icons/md';
import { Consent, ConsentType } from 'app/area/user-profile/my-notifications/types';
import { MyNotificationTranslation } from 'app/area/user-profile/my-notifications/constants';
import styles from './consent-item.scss';

interface ConsentItemExternalProps extends Consent {
  isChannelActive: boolean;
  translation: MyNotificationTranslation;
  children?: React.ReactNode;
}
export class ConsentItem extends React.PureComponent<ConsentItemExternalProps> {
  private getText() {
    const { type, value: { name }, translation } = this.props;
    const texts = {
      [ConsentType.sms]: {
        className: 'smsStyles',
        typeText: translation.sms_text,
        nameText: name,
        icon: MdPhone
      }
    };

    return texts[type] || { className: '', typeText: '', nameText: '', icon: undefined };
  }

  public render() {
    const text = this.getText();
    const IconComponent = text.icon;

    return <div className={styles.consentItemWrapper}>
      <div className={`${styles.consentItem} ${this.props.isChannelActive ? styles.consentItemActive : styles.consentItemInactive}`}>
        <div className={styles.contextMenu}>
          {this.props.children}
        </div>
        <div>
          <div className={styles.consentTopPanel}>
            <div className={`${styles.displayColorWrapper} ${styles[text.className]}`} />
          </div>
          <div className={`${styles.consentHeaderPanel} compact row`}>
            <div className={styles.headerKey}><IconComponent /></div>
            <div className={styles.leftPanel}>
              <div className={styles.leftPanelInfo}>
                <span>
                  <div className={`${styles.code} ${styles[text.className]}`}>
                    {text.typeText}
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.consentName}>{text.nameText}</div>
      </div>
    </div>;
  }
}
